import React, { createContext, useContext, useEffect, useState } from "react";
import { onAuthStateChanged, signInWithEmailAndPassword, signOut } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { auth, db } from "../firebase";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [role, setRole] = useState(null); // "superadmin" | "admin" | "applicant"
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (u) => {
      setUser(u);
      if (u) {
        try {
          const adminRef = doc(db, "admins", u.uid);
          const adminSnap = await getDoc(adminRef);
          if (adminSnap.exists()) {
            setRole(adminSnap.data().role || "admin");
            setProfile(adminSnap.data());
          } else {
            // try applicant lookup
            const appRef = doc(db, "applicant_accounts", u.uid);
            const appSnap = await getDoc(appRef);
            if (appSnap.exists()) {
              setRole("applicant");
              setProfile(appSnap.data());
            } else {
              setRole(null);
            }
          }
        } catch (e) { console.error(e); }
      } else {
        setRole(null);
        setProfile(null);
      }
      setLoading(false);
    });
    return () => unsub();
  }, []);

  const login = (email, pw) => signInWithEmailAndPassword(auth, email, pw);
  const logout = () => signOut(auth);

  return (
    <AuthContext.Provider value={{ user, role, profile, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}
